import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const Checklogin = ({ children }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    // const token = sessionStorage.getItem('token');
    
    if (!token) {
        toast.error('Please login to access this page');
      navigate('/login');
    }
  }, [navigate]);
  
  return children;
};

export default Checklogin;